import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { fetchVersionPolicy, updateVersionPolicyApi } from "../services/appConfigService";
import { resolveApiErrorMessage } from "../utils/resolveApiErrorMessage";

const VERSION_POLICY_QK = ["app-config", "version-policy"];

export const useVersionPolicy = () =>
  useQuery({ queryKey: VERSION_POLICY_QK, queryFn: fetchVersionPolicy });

export const useUpdateVersionPolicy = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateVersionPolicyApi,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: VERSION_POLICY_QK });
      toast.success("Politique de version enregistrée", { autoClose: 3000 });
    },
    onError: (err) => {
      toast.error(resolveApiErrorMessage(err, "Politique de version non enregistrée"), {
        autoClose: 5000,
      });
    },
  });
};
